import { CommonMessage } from './CommonMessage';
import { MessageType } from './MessageType';

export class PongMessage implements CommonMessage {
  t = MessageType.PONG;
  d = {};
}
